module.exports = __webpack_public_path__ + "media/images/flags/32/Moldova-7eed894d112e3f84364c12b1e78dacb4.png";